import React from "react";
import HilightTable from "../../../../../components/HilightTable";
import {Button, Spinner} from "react-bootstrap";
import {modalActions} from "../../../../../actions/modal.actions";
import {withNamespaces} from "react-i18next";
import {pxmModbusActions} from "../../../../../actions/pxm-modbus.actions";
import {connect} from "react-redux";
import DmxPxmSceneForm from "../_forms/DmxPxmSceneForm";

const DmxPxmSceneTable = ({ t, list, showModal, editPxmScene, removePxmScene}) => {

    const openModalEditScene = (row) => {
        showModal({
            open: true,
            title: t('edit-dmx-scene'),
            component: <DmxPxmSceneForm data={row} submitForm={(model) => editPxmScene(model)} />
        }, "formModal");
    };

    const openModalDeleteScene = (row) => {
        showModal({
            open: true,
            title: t('are-you-sure'),
            message: t('delete-msg') + `<h5> ${row.label} </h5>`,
            confirmLabel: t('delete-btn'),
            confirmIcon: 'fa-trash',
            classNameBtnConfirm: 'btn-danger',
            dataId: row.id,
            confirmAction: () => {
                removePxmScene(row.id, row.networkDeviceId)
            },
        }, 'confirm');
    };

    const columns = [
        {
            Header: 'modbus-registry-address',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            accessor: 'registryAddress'
        },
        {
            Header: 'modbus-value',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            accessor: 'value'
        },
        {
            Header: 'label',
            accessor: 'label'
        },
        {
            Header: 'action',
            headerClassName: "text-center",
            classNameRow: 'text-center',
            styleHeader: {width: '1px' },
            styleRow: { width: '1px' },
            Cell: (props) => {
                const row = props.row.original;

                let translateLabel = ""
                if(row.turnOnScene === true) {
                    translateLabel = 'exhibition-on'
                }
                else if(row.turnOnScene === false) {
                    translateLabel = 'exhibition-off'
                }
                else if(row.turnOnScene === null) {
                    translateLabel = 'additional'
                }

                return (<b>{t(translateLabel)}</b>)
            }
        },
        {
            Header: 'actions',
            headerClassName: "text-right",
            classNameRow: 'text-right',
            styleHeader: {width: '1px'},
            styleRow: {width: '1px'},
            Cell: (props) => {
                const row = props.row.original;
                return (
                    <React.Fragment>
                        <Button className="mx-1" variant={"primary"} onClick={() => openModalEditScene(row)}>
                            <i className="fas fa-edit" />
                        </Button>
                        <Button className="mx-1" variant={"danger"} onClick={() => openModalDeleteScene(row)}>
                            <i className="fas fa-trash" />
                        </Button>
                    </React.Fragment>
                );
            }
        }
    ];

    const tableResult = (
        list ?
            list.length === 0 ? (
                <div className="text-center p-4">
                    <h3>{t('dali-group-no-content')}</h3>
                </div>
            ) : (
                <HilightTable
                    columns={columns}
                    data={list}
                />
            ) : (
                <React.Fragment>
                    <Spinner animation={"border"} />
                    <p>Loading ...</p>
                </React.Fragment>
            )
    );

    return (
        <div className="col-md-12 mx-0 my-3 p-0">
            { tableResult }
        </div>
    );
};

const mapDispatchToProps = dispatch => ({
    hideModel: () => dispatch(modalActions.hideModal()),
    showModal: (modalProps, modalType) => {
       dispatch(modalActions.showModal({modalProps, modalType}))
    },
    editPxmScene: (sceneModel) => {
        dispatch(pxmModbusActions.editScene(sceneModel))
    },
    removePxmScene: (sceneId, networkDeviceId) => {
        dispatch(pxmModbusActions.deleteScene(sceneId, networkDeviceId))
    }
});
export default withNamespaces()(connect(null, mapDispatchToProps)(DmxPxmSceneTable));
